/* tslint:disable */
export var icon = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"13\"><path fill=\"#3899EC\" fill-rule=\"evenodd\" d=\"M10.382 10.099a6 6 0 11.755-.996L15 12l-.75 1-3.868-2.901zM6 11A5 5 0 106 1a5 5 0 000 10z\" opacity=\".8\"/></svg>\n";
//# sourceMappingURL=search.svg.js.map